import { Icon, Menu, MenuItem, ClickAwayListener } from '@mui/material';

import { useState } from 'react';

import { ReactComponent as MeatBall } from 'common/assets/images/meat-ball.svg';

import promptBuilderStyles from '../PromptBuilderLayout.module.scss';

interface IPromptMenuCell {
	isEditable: boolean;
	isDeleteDisabled: boolean;
	handleClone: () => void;
	handleEdit: () => void;
	handleDelete: () => void;
}
const PromptTableMenu = (props: IPromptMenuCell) => {
	const {
		isEditable,
		isDeleteDisabled,
		handleClone,
		handleEdit,
		handleDelete,
	} = props;
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const { iconFillColor } = promptBuilderStyles;

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<ClickAwayListener onClickAway={handleClose}>
			<div>
				<Icon
					id="basic-menu-icon"
					onClick={handleClick}
					sx={{ cursor: 'pointer' }}
				>
					<MeatBall data-testid="meatball-icon" fill={iconFillColor} />
				</Icon>
				<Menu
					keepMounted
					id="basic-menu-display"
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={handleClose}
					transformOrigin={{ horizontal: 'right', vertical: 'top' }}
					anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
					MenuListProps={{
						'aria-labelledby': 'basic-button',
					}}
					data-testid="actions-menu"
				>
					<MenuItem onClick={handleEdit} data-testid="edit_read">
						{isEditable ? 'Edit' : 'Read'}
					</MenuItem>
					<MenuItem onClick={handleClone} data-testid="clone">
						Duplicate
					</MenuItem>
					<MenuItem
						onClick={handleDelete}
						disabled={isDeleteDisabled}
						data-testid="delete"
					>
						Delete
					</MenuItem>
				</Menu>
			</div>
		</ClickAwayListener>
	);
};

export default PromptTableMenu;
